import { useState } from 'react'

import dayjs, { Dayjs } from 'dayjs'

export type DateRangeValue = [Dayjs | null, Dayjs | null]
export type DateRangeStringValue = [string | null, string | null]

export const toDayjs = ([from, to]: DateRangeStringValue): DateRangeValue => [
  from ? dayjs(from) : null,
  to ? dayjs(to) : null,
]

interface UseDateRangePopoverArgs {
  id: string
  value: DateRangeStringValue
  onChange: (value: DateRangeStringValue) => void
}

export const useDateRangePopover = ({
  id,
  value,
  onChange,
}: UseDateRangePopoverArgs) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const [pendingValue, setPendingValue] = useState<DateRangeValue>(
    toDayjs(value),
  )

  const open = Boolean(anchorEl)
  const popoverId = open ? `${id}-popover` : undefined

  const handleOpen = (e: React.MouseEvent<HTMLElement>) => {
    setPendingValue(toDayjs(value))
    setAnchorEl(e.currentTarget)
  }

  const handleAccept = () => {
    onChange([
      pendingValue[0] ? pendingValue[0].format('YYYY-MM-DD') : null,
      pendingValue[1] ? pendingValue[1].format('YYYY-MM-DD') : null,
    ])
    setAnchorEl(null)
  }

  const handleCancel = () => {
    setPendingValue(toDayjs(value))
    setAnchorEl(null)
  }

  return {
    anchorEl,
    pendingValue,
    setPendingValue,
    open,
    popoverId,
    handleOpen,
    handleAccept,
    handleCancel,
  }
}
